<template>
<div id="product-preview" v-if="product">
    <div class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <button @click.prevent="product = null" type="button" class="close float-right d-inline-block d-sm-none">
                                <span aria-hidden="true"><div class="icon icon-close"></div></span>
                            </button>
                            <h2 class="d-block d-sm-none">{{ product.name }}</h2>
                            <images :images="product.images"></images>
                        </div>
                        <div class="col-sm-6">
                            <button @click.prevent="product = null" type="button" class="close float-right d-none d-sm-inline-block">
                                <span aria-hidden="true"><div class="icon icon-close"></div></span>
                            </button>
                            <h2 class="d-none d-sm-block">{{ product.name }}</h2>
                            <add-to-cart :product="product" :cols="12"></add-to-cart>
                            <properties :product="product" v-if="!isSewingMachine"></properties>
                            <div class="row mt-4" v-else>
                              <div class="col-12">
                                  <div class="frameTitle">{{$t('product.properties.info.title')}}</div>
                                  <div class="frameContent">
                                    {{ product.short_description }}
                                  </div>
                              </div>
                          </div>
                            <div class="row justify-content-end">
                                <div class="col-md-6 col-sm-3 col-xs-6">
                                    <a :href="`/${$t('routes.product')}/${product.nice_url}`" class="btn btn-outline-salmon-strong float-right w-100">
                                        {{$t('general.singleProduct.toProduct')}}
                                        <i class="icon icon-go-to"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <div class="modal-backdrop fade show" @click.prevent="product = null"></div>
    </div>
</div>
</template>

<script>
/* global App */

import xhr from '@Core/xhr'
import Images from './ProductImages'
import Properties from './ProductProperties'
import AddToCart from '../basket/AddToCart'

export default {

  components: {
    Images,
    AddToCart,
    Properties
  },

  data () {
    return {
      product: null,
      isSewingMachine: false
    }
  },

  created () {
    App.dispatcher.listen('quick-preview.open', async pid => {
      let response = await new xhr().get(`/product/${pid}`)
      this.product = response.product
      this.isSewingMachine = response.isSewingMachine
    })
  }

}
</script>
